module.exports = __webpack_public_path__ + "img/logo.779f0982.svg";